import React from 'react';

interface FupOrProps {
  width?: number;
  height?: number;
}

const FupOr: React.FC<FupOrProps> = ({ width = 80, height = 60 }) => (
  <svg width={width} height={height} viewBox="0 0 80 60" xmlns="http://www.w3.org/2000/svg">
    {/* Baustein-Körper mit gebogenen Linien */}
    <path d="M 10 10 Q 20 30 10 50 L 40 50 Q 70 30 40 10 Z" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    
    {/* Eingangs-Ankerpunkte */}
    <circle cx="5" cy="20" r="3" fill="#0D3559" />
    <circle cx="5" cy="40" r="3" fill="#0D3559" />
    
    {/* Ausgangs-Ankerpunkt */}
    <circle cx="75" cy="30" r="3" fill="#0D3559" />
    
    {/* Label */}
    <text x="30" y="35" fontSize="16" fill="#0D3559" textAnchor="middle" fontWeight="bold">≥1</text>
  </svg>
);

export default FupOr;
